import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading, setUser } = useAuth();
    const location = useLocation();
    const stateUser = location.state?.user;

    // Hydrate context from navigate state once if AuthCallback passed the user
    useEffect(() => {
        if (stateUser && !user) setUser(stateUser);
    }, [stateUser, user, setUser]);

    if (stateUser || user) return children;
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="h-8 w-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }
    return <Navigate to="/" replace />;
}
